import * as React from "react";
const SvgCheckmarkB500 = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="none" {...props}>
    <path
      fill="#9D7D54"
      fillRule="evenodd"
      d="M16.16 3.246a.65.65 0 0 1 .094.914l-8.55 10.5a.65.65 0 0 1-.955.058l-4.95-4.773A.65.65 0 0 1 2.7 9.01l4.441 4.282 8.104-9.951a.65.65 0 0 1 .914-.094"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCheckmarkB500;
